<template>
    <div
        v-for="(subNav, index) in subData"
        :key="subNav.id"
        class="subItem__title"
    >
        <div v-if="subNav.netNav.length" @click="toggleNet(index)">
            <div class="itemContent">
                {{ subNav.title }}
                <img
                    :class="{
                        'rotate--active': currentIndex === index,
                    }"
                    src="@/assets/images/arrow.png"
                    alt=""
                />
            </div>
            <transition name="dropNet">
                <ul class="subNet" v-show="currentIndex === index">
                    <li
                        v-for="subNet in subNav.netNav"
                        :key="subNet.id"
                        class="subNet__item"
                        :class="{ 'subNet__item--active': showItemLink }"
                    >
                        <router-link
                            @click="$emit('closeNav')"
                            class="netRouterLink"
                            :to="{
                                name: 'Content',
                                params: {
                                    route: subNet.route,
                                },
                            }"
                            >{{ subNet.title }}
                        </router-link>
                    </li>
                </ul>
            </transition>
        </div>
        <router-link
            @click="$emit('closeNav')"
            class="routerLink"
            v-else
            :to="{
                name: 'Content',
                params: { route: subNav.route },
            }"
            >{{ subNav.title }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: "SubNav",
    emits: ["closeNav"],
    props: {
        subData: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showNet: false,
            currentIndex: "",
            showItemLink: false,
        };
    },
    methods: {
        toggleNet(index) {
            if (this.currentIndex === index) {
                this.showNet = !this.showNet;
                this.currentIndex = "";
                setTimeout(() => {
                    this.showItemLink = !this.showItemLink;
                }, 0);
                return;
            }
            this.currentIndex = index;
            this.showNet = true;
            setTimeout(() => {
                this.showItemLink = true;
            }, 0);
        },
    },
};
</script>

<style lang="sass" scoped>
.dropNet-enter-active,
.dropNet-leave-active
	transition: transform .4s
	transform: translateY(-10px)

.dropNet-enter-to,
.dropNet-leave-from
	transform: translateY(0px)

.subItem__title
		font-size: 14px
		font-weight: lighter
		padding: 6px 30px
		cursor: pointer
		transition: opacity .3s
		a
			color: #fff
			text-decoration: none
		.subNet
			margin-top: 16px
			list-style-type: circle
			padding-inline-start: 22px
			&__item
				margin-top: 10px
				padding: 0 5px
				transition: opacity .6s
				opacity: 0
				&--active
					opacity: 1
				.netRouterLink
					&:hover
						opacity: 0.7
						text-decoration: underline
		.routerLink
			&:hover
				opacity: 0.7

		.itemContent
			font-size: 14px
			&:hover
				opacity: 0.7
			img
				width: 8px
				margin-left: 5px
				transition: transform .7s
				transform: rotate(-180deg)
			.rotate--active
				transform: rotate(0deg)
</style>
